const constants = {
  URL_NEO_FEED: 'https://api.nasa.gov/neo/rest/v1/feed?start_date=2015-09-07&end_date=2015-09-08&api_key=',
  URL_APOD: `https://api.nasa.gov/planetary/apod?api_key=`,
  URL_NIMAGES: 'https://images-api.nasa.gov',
  URL_ROVERS: 'https://api.nasa.gov/mars-photos/api/v1/rovers/',
  URL_WEATHER: 'https://api.nasa.gov/insight_weather/?api_key='
  
};

export default constants;